"use client";

import { JobCard } from "./job-card";
import { useCountryContext } from "@/providers/country-provider";

export const JobBoard = () => {
	const { jobBoard } = useCountryContext();
	return (
		<div className="mt-10">
			<h3 className="mb-3 text-xl font-bold md:text-2xl lg:text-3xl">{jobBoard.title}</h3>
			<div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
				{jobBoard.jobs.map((item) => (
					<JobCard key={item.title + item.applyLink} {...item} />
				))}
			</div>
		</div>
	);
};
